"use strict";

exports.__esModule = true;
exports.getMargin = getMargin;
exports.getPadding = getPadding;
exports.addMarginClasses = addMarginClasses;
exports.addPaddingClasses = addPaddingClasses;
exports.addSpacingClasses = addSpacingClasses;
exports.paddingProps = exports.marginProps = exports.sizeProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
utils to handle common logic related to adding spacing between/around components via props
*/
var sizeProps = _propTypes["default"].oneOf(['none', 'xs', 'sm', 'smd', 'md', 'mlg', 'lg', 'xl']);

exports.sizeProps = sizeProps;

var marginProps = _propTypes["default"].shape({
  all: sizeProps,
  horizontal: sizeProps,
  vertical: sizeProps,
  top: sizeProps,
  right: sizeProps,
  bottom: sizeProps,
  left: sizeProps
});

exports.marginProps = marginProps;

var paddingProps = _propTypes["default"].shape({
  all: sizeProps,
  horizontal: sizeProps,
  vertical: sizeProps,
  top: sizeProps,
  right: sizeProps,
  bottom: sizeProps,
  left: sizeProps
});

exports.paddingProps = paddingProps;

function getSpacing(prefix, settings) {
  if (!settings || !prefix) return null;
  var settingsArray = Object.keys(settings);
  if (settingsArray.length === 0) return null;
  var sidemap = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bot',
    horizontal: 'hor',
    vertical: 'ver'
  };
  return settingsArray.map(function (side) {
    if (side === 'all') return prefix + "-" + settings[side];
    return prefix + "-" + sidemap[side] + "-" + settings[side];
  });
}
/*
Given margn props, generates the CSS classes to use
*/


function getMargin(margin) {
  return getSpacing('st_m', margin);
}

function getPadding(padding) {
  return getSpacing('st_p', padding);
}
/*
given array of original css class arrays
and margin props
return new array with margin classes, or the original aray
*/


function addMarginClasses(margin, cssClasses) {
  if (cssClasses === void 0) {
    cssClasses = [];
  }

  if (!margin) return cssClasses;
  return (cssClasses || []).concat(getMargin(margin));
}
/*
given array of original css class arrays
and padding props
return new array with margin classes, or the original aray
*/


function addPaddingClasses(padding, cssClasses) {
  if (cssClasses === void 0) {
    cssClasses = [];
  }

  if (!padding) return cssClasses;
  return (cssClasses || []).concat(getPadding(padding));
}
/*
given margin or padding props
add css classnames
and return new array of css classes
*/


function addSpacingClasses(_ref) {
  var padding = _ref.padding,
      margin = _ref.margin,
      cssClasses = _ref.cssClasses;
  var newClasses = cssClasses || [];
  newClasses = addPaddingClasses(padding, newClasses);
  newClasses = addMarginClasses(margin, newClasses);
  return newClasses;
}